import { Field, reduxForm } from "redux-form";
import { Modal } from "components";
import { Button, Checkbox, Input, Select } from "expano-components";
import { createWarehouse } from "actions/warehouses";
import country_code_options from "utils/country_code_options";
import { useMainList } from "components/MainList/context/provider";

import { ReactComponent as EditIcon } from "icons/edit.svg";

const InputField = (props) => <Input {...props} />;
const SelectField = (props) => <Select {...props} />;
const CheckField = (props) => <Checkbox {...props} />;

const ModalCreateWarehouse = ({
  change,
  invalid,
  pristine,
  handleSubmit,
  handleClose,
  initialValues,
}) => {
  const { refetch } = useMainList();
  const onSubmit = async (values) => {
    try {
      await createWarehouse(values);
      handleClose();
      refetch();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        icon: <EditIcon />,
        title: "Dodaj magazyn",
      }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <button
            disabled={invalid || pristine}
            onClick={handleSubmit(onSubmit)}
            type="submit"
            className="btn btn-sm btn-green"
          >
            <span>Zapisz</span>
          </button>
        </>
      }
    >
      <form noValidate>
        <table className="modal-table">
          <tbody>
            <tr>
              <td>Nazwa</td>
              <td>
                <Field placeholder="Nazwa" name="name" component={InputField} />
              </td>
            </tr>
            <tr>
              <td>Ulica</td>
              <td>
                <Field
                  placeholder="Ulica"
                  name="street"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Miasto</td>
              <td>
                <Field
                  placeholder="Miasto"
                  name="city"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Kod pocztowy</td>
              <td>
                <Field
                  placeholder="Kod pocztowy"
                  name="zip_code"
                  component={InputField}
                />
              </td>
            </tr>
            <tr>
              <td>Kraj</td>
              <td>
                <Field
                  name="country_code"
                  component={SelectField}
                  handleChange={(value) => change("country_code", value)}
                  options={country_code_options}
                  defaultValue={country_code_options.find(
                    ({ value }) => value === initialValues.country_code
                  )}
                />
              </td>
            </tr>
            <tr>
              <td>Typ magazynu</td>
              <td>
                <div className="check-holder">
                  <Field
                    type="checkbox"
                    id="is_virtual"
                    name="is_virtual"
                    label="Magazyn wirtualny"
                    component={CheckField}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </Modal>
  );
};

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "Pole wymagane!";
  }
  return errors;
};

export default reduxForm({
  form: "create-warehouse",
  validate,
  enableReinitialize: true,
  initialValues: {
    name: "",
    street: "",
    zip_code: "",
    city: "",
    country_code: "PL",
    is_virtual: false,
  },
})(ModalCreateWarehouse);
